import React from 'react';
import { Hero } from '../components/sales/Hero';
import { WhySection } from '../components/sales/WhySection';
import { SilentSymptomsSection } from '../components/sales/SilentSymptomsSection';
import { WhyNothingElseWorkedSection } from '../components/sales/WhyNothingElseWorkedSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { JourneyTimeline } from '../components/sales/JourneyTimeline';
import { SocialProofSection } from '../components/sales/SocialProofSection';
import { VideoSection } from '../components/sales/VideoSection';
import { IngredientsSection } from '../components/sales/IngredientsSection';
import { PricingBundles } from '../components/sales/PricingBundles';
import { FreeBonusStack } from '../components/sales/FreeBonusStack';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { FAQ } from '../components/sales/FAQ';
import { FinalClose } from '../components/sales/FinalClose';
import { Footer } from '../components/sales/Footer';
export function LymphoriaXPage() {
  return <div className="min-h-screen bg-white font-sans text-[#1B5E20]" data-id="element-313">
      {/* Top Banner */}
      <div className="bg-[#10B981] text-white text-center py-3 text-sm font-bold tracking-wide" data-id="element-314">
        🌍 WORLDWIDE FREE SHIPPING + 90-DAY GUARANTEE
      </div>

      <main data-id="element-315">
        <Hero data-id="element-316" />
        <WhySection data-id="element-317" />
        <SilentSymptomsSection data-id="element-318" />
        <WhyNothingElseWorkedSection data-id="element-319" />
        <MechanismSection data-id="element-320" />
        <JourneyTimeline data-id="element-321" />
        <SocialProofSection data-id="element-322" />
        <VideoSection data-id="element-323" />
        <IngredientsSection data-id="element-324" />
        <PricingBundles data-id="element-325" />
        <FreeBonusStack data-id="element-326" />
        <GuaranteeSection data-id="element-327" />
        <FAQ data-id="element-328" />
        <FinalClose data-id="element-329" />
      </main>

      <Footer data-id="element-330" />
    </div>;
}